'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactI18next = require('react-i18next');

var _TicketDetails = require('./TicketDetails.jsx');

var _TicketDetails2 = _interopRequireDefault(_TicketDetails);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function TotalSplit(props) {
  var components = props.components,
      t = props.t;
  var faresBreakDown = props.faresBreakDown;


  var styleTicketHeader = {
    backgroundColor: components.TicketHeader.backgroundColor
  };

  var styleTicketDetails = {
    backgroundColor: components.TicketDetails.backgroundColor
  };

  var styleTicketHeaderTicketText = {
    color: components.TicketHeaderTicketText.color,
    fontSize: components.TicketHeaderTicketText.fontSize,
    fontWeight: components.TicketHeaderTicketText.fontWeight,
    fontStyle: components.TicketHeaderTicketText.fontStyle,
    textDecoration: components.TicketHeaderTicketText.textDecoration,
    fontFamily: components.TicketHeaderTicketText.fontFamily
  };

  return _react2.default.createElement(
    'table',
    { style: { borderCollapse: 'collapse', width: '100%' }, 'data-component': 'TotalSplit' },
    _react2.default.createElement(
      'tbody',
      null,
      faresBreakDown.map(function (ticketFares, i) {
        return _react2.default.createElement(
          'tr',
          { key: i },
          _react2.default.createElement(
            'td',
            { style: { padding: '0' } },
            _react2.default.createElement(
              'table',
              { style: { borderCollapse: 'collapse', width: '100%' }, 'data-component': 'TotalSplit__aux' },
              _react2.default.createElement(
                'tbody',
                null,
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'td',
                    { style: (0, _extends3.default)({}, styleTicketHeader, { padding: '10px' }) },
                    _react2.default.createElement(
                      'span',
                      { style: styleTicketHeaderTicketText },
                      t('air.ticket'),
                      ' ',
                      i + 1,
                      ':'
                    )
                  )
                ),
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'td',
                    { style: (0, _extends3.default)({}, styleTicketDetails, { padding: '10px' }) },
                    _react2.default.createElement(_TicketDetails2.default, {
                      perPassenger: ticketFares.optionPrice.priceItemList,
                      total: ticketFares.optionPrice.totalPriceItem
                    })
                  )
                )
              )
            )
          )
        );
      })
    )
  );
}

var mstp = function mstp(state) {
  return {
    components: state.templateApplication.templates.currentTemplate.components
  };
};

exports.default = (0, _reactI18next.translate)()((0, _reactRedux.connect)(mstp)(TotalSplit));
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TemplateComponents/Air/Email/TotalSplit.jsx
// module id = 1489
// module chunks = 0